import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatTag = createCustomElementWrapper('kat-tag', 'KatTag', {
    'katAriaLabel': 'kat-aria-label',
}, {
    'onDismiss': 'dismiss',
});
